import React from 'react';

const Clients = () => {
    const sectors = [
        'Financial Services',
        'Healthcare',
        'Agriculture',
        'Mining',
        'Retail',
        'Energy',
        'Logistics',
        'Education'
    ];

    const marqueeList = [...sectors, ...sectors];

    return (
        <section className="clients-section" aria-label="Sector experience">
            <div className="container">
                <div className="section-header section-header--compact fade-in">
                    <p className="eyebrow">Built for Regulated, Data-Heavy Teams</p>
                </div>

                <div className="marquee-wrapper fade-in">
                    <div className="marquee-track">
                        {marqueeList.map((sector, index) => (
                            <span key={`${sector}-${index}`} className="client-logo">
                                {sector}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Clients;
